// extracted by mini-css-extract-plugin
export var grid = "Services-module--grid--illIF";
export var hasImg = "Services-module--hasImg--TqJJJ";
export var image = "Services-module--image--Bc+Nx";
export var item = "Services-module--item--Kbemr";
export var noImg = "Services-module--noImg--XDimw";
export var text = "Services-module--text--kTys1";